<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <div style="width: 10rem">
                <pr-input-radio
                  [isDefault]="false"
                  [columns]="2"
                  formControlName="isTrue"
                  [derrors]="derrors"
                  [toggle]="true"
                >
                </pr-input-radio>
              </div>
              @if (owner?.get('isTrue')?.value == true) {
                <ng-conainer>
                  <residences
                    [hidden]="
                      owner?.get('isTrue')?.value == false ||
                      owner?.get('isTrue')?.value == null
                    "
                    formArrayName="otherNif"
                    [derrors]="derrors"
                  >
                  </residences>
                </ng-conainer>
              }
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
